export const primaryAdminNavigation = [
  { path: "/admin/dashboard", label: "总览" },
  { path: "/admin/users", label: "用户" },
  { path: "/admin/orders", label: "订单" },
] as const

export const secondaryAdminNavigation = [
  { path: "/admin/tasks", label: "任务" },
  { path: "/admin/devices", label: "设备" },
  { path: "/admin/cdk", label: "CDK" },
  { path: "/admin/logs", label: "日志" },
  { path: "/admin/settings", label: "设置" },
] as const

export function matchesAdminPath(pathname: string, path: string) {
  return pathname === path || pathname.startsWith(`${path}/`)
}

export function isSecondaryAdminPath(pathname: string) {
  return secondaryAdminNavigation.some((item) => matchesAdminPath(pathname, item.path))
}
